module.exports = __webpack_public_path__ + "img/matchups.5b818b85.png";